<template>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card m-0">
        <div class="card-header bg-geogo-top-left p-2">
          <h3 class="card-title text-white">
            <i class="fas fa-map mr-2"></i>
            Administrar Sitios
          </h3>
        </div>
        <div
          class="card-body"
          v-if="
            listasForms.sitios.length > 0 &&
              $parent.form.estado == 1 &&
              $store.getters.can('argentina.bloques.edit')
          "
        >
          <div class="row">
            <div class="col-md-10">
              <label for="sitio">Sitios Disponibles</label>
              <v-select
                id="sitio"
                class="form-control form-control-sm p-0"
                :class="[
                  $store.getters.getDarkMode ? 'dark-vselect' : '',
                  $v.form.id.$invalid ? 'is-invalid' : 'is-valid',
                ]"
                v-model="form.id"
                label="nombre"
                :options="listasForms.sitios"
                :reduce="(s) => s.id"
              >
              </v-select>
            </div>
            <div class="col-md-2 pt-4">
              <button
                class="btn bg-primary float-right"
                v-show="!$v.form.$invalid"
                v-if="$store.getters.can('argentina.bloques.edit')"
                @click="add()"
              >
                <i class="fas fa-save"></i><br />
              </button>
            </div>
          </div>
        </div>
        <div
          class="card-body table-responsive"
          :class="sitios.length > 0 ? 'p-0' : ''"
        >
          <table
            v-if="sitios.length > 0"
            id="sitios"
            class="table table-bordered table-striped table-hover table-sm"
          >
            <thead class="bg-dark">
              <tr>
                <th>Sitio</th>
                <th class="col-2">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in sitios" :key="data.id">
                <td v-text="data.nombre"></td>
                <td class="text-right">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    v-if="
                      $store.getters.can('argentina.bloques.delete') &&
                        form.estado != 2
                    "
                    @click="destroy(data.id)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            v-else
            class="col-md-12 callout callout-warning alert-default-warning small-box text-dark m-0"
          >
            <h5 class="m-0">
              <i class="fas fa-info mr-2"></i> No hay sitios asignados.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "BloqueSitios",

  components: {
    vSelect,
  },

  data() {
    return {
      sitios: [],
      form: {
        id: null,
        bloque_id: this.$parent.id,
      },
      listasForms: {
        sitios: [],
      },
    };
  },

  validations: {
    form: {
      id: {
        required,
      },
    },
  },

  methods: {
    getIndex() {
      this.sitios = this.$parent.form.sitios;
      this.form = {
        id: null,
        bloque_id: this.$parent.id,
      };
      this.listasForms.sitios = this.$parent.listasForms.sitios.filter(
        (s) => s.bloque_id !== this.$parent.id
      );
    },

    add() {
      if (!this.$v.form.$invalid) {
        this.$parent.cargando = true;
        axios({
          method: "PUT",
          url: "/api/argentina/sitios",
          data: this.form,
        })
          .then(async () => {
            this.$swal({
              icon: "success",
              title: "Se asignó el sitio exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            await this.$parent.getSitios();
            this.$parent.getIndex();
            this.$parent.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$parent.cargando = false;
          });
      }
    },

    destroy(id) {
      const params = {
        id,
        bloque_id: 0,
      };
      this.$swal({
        title: "Está seguro de retirar este Sitio?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;
          axios({
            method: "PUT",
            url: "/api/argentina/sitios",
            data: params,
          })
            .then(async (response) => {
              this.$parent.cargando = false;
              this.$swal({
                icon: "success",
                title: "Se eliminó el Sitio exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              await this.$parent.getSitios();
              this.$parent.getIndex();
            })
            .catch((error) => {
              this.$parent.cargando = false;
              this.$swal({
                icon: "error",
                title: "Ocurrió un error: " + error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
  },
};
</script>
